// fiuhb_frontend/src/services/finance_services/expenseService.js
import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const Finance_Base_Url = `${API_BASE_URL}/finances`;

// Expense Category Services
export const getExpenseCategories = async (invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/expenses/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching expense categories:', error);
    throw error;
  }
};

export const createExpenseCategory = async (categoryData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/expenses/create/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(categoryData),
    });
    return response;
  } catch (error) {
    console.error('Error creating expense category:', error);
    throw error;
  }
};

export const getExpenseCategory = async (categoryId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/expenses/${categoryId}/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching expense category:', error);
    throw error;
  }
};

export const updateExpenseCategory = async (categoryId, categoryData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/expenses/${categoryId}/update/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(categoryData),
    });
    return response;
  } catch (error) {
    console.error('Error updating expense category:', error);
    throw error;
  }
};

export const deleteExpenseCategory = async (categoryId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/expenses/${categoryId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting expense category:', error);
    throw error;
  }
};

// Expense Services
export const getExpenses = async (page = 1, pageSize = 10, filters = {}, invitationId = null) => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString()
  });
  
  // Add optional filter parameters
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.category) {
    params.append('category', filters.category);
  }
  if (filters.date_range) {
    params.append('date_range', filters.date_range);
  }
  if (filters.start_date) {
    params.append('start_date', filters.start_date);
  }
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }
  if (filters.payment_method) {
    params.append('payment_method', filters.payment_method);
  }
  
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/expenses/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching expenses:', error);
    throw error;
  }
};

export const createExpense = async (expenseData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/expenses/create/?${params.toString()}`;
  console.log('Creating expense with data:', expenseData);
  
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(expenseData),
    });
    console.log('Create expense response:', response);
    return response;
  } catch (error) {
    console.error('Error creating expense:', error);
    throw error;
  }
};

export const getExpense = async (expenseId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/expenses/${expenseId}/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching expense:', error);
    throw error;
  }
};

export const updateExpense = async (expenseId, expenseData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/expenses/${expenseId}/update/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(expenseData),
    });
    return response;
  } catch (error) {
    console.error('Error updating expense:', error);
    throw error;
  }
};

export const deleteExpense = async (expenseId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/expenses/${expenseId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting expense:', error);
    throw error;
  }
};

